import { render, staticRenderFns } from "./VendorDashboard.vue?vue&type=template&id=c98bb72c&scoped=true&"
import script from "./VendorDashboard.vue?vue&type=script&lang=js&"
export * from "./VendorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./VendorDashboard.vue?vue&type=style&index=0&id=c98bb72c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98bb72c",
  null
  
)

export default component.exports